/* ============================================================
   shopCategoryView — 3d4c488f: pure view model for the shop
   category chips (MakerWorld-style two rows: roots + subs of
   the selected root). No React here so it stays unit-testable.
   ============================================================ */

import type { ProductCategoryNode } from '../types/category';

export interface CategoryChip {
  id: string;
  name: string;
  /** own active-product count (+ children for roots, like MakerWorld). */
  count: number;
  active: boolean;
}

export interface ShopCategoryFilterView {
  roots: CategoryChip[];
  /** subcategory chips of the selected root (empty when none selected). */
  subs: CategoryChip[];
}

export function buildCategoryFilterView(
  tree: ProductCategoryNode[],
  selectedRootId: string | null,
  selectedSubId: string | null,
): ShopCategoryFilterView {
  const roots: CategoryChip[] = tree.map((root) => ({
    id: root.id,
    name: root.name,
    count: root.productCount + root.children.reduce((sum, c) => sum + c.productCount, 0),
    active: root.id === selectedRootId,
  }));

  const selectedRoot = tree.find((root) => root.id === selectedRootId) ?? null;
  const subs: CategoryChip[] = (selectedRoot?.children ?? []).map((sub) => ({
    id: sub.id,
    name: sub.name,
    count: sub.productCount,
    active: sub.id === selectedSubId,
  }));

  return { roots, subs };
}

/** Effective browse category id: sub wins over its root (more specific). */
export function resolveBrowseCategoryId(
  selectedRootId: string | null,
  selectedSubId: string | null,
): string | undefined {
  return selectedSubId ?? selectedRootId ?? undefined;
}
